/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { CeproDocCreateRequest } from '../types/CeproDocCreate';
import type { CeproDocCreateResponse } from '../types/CeproDocCreate';

export type CeproDocsCreateRequest = CeproDocCreateRequest;
export type CeproDocsCreateResponse = CeproDocCreateResponse;

export type CeproDocsCreateQuery = {};

/**
 * POST /dmx-server/cepro_docs/
 *
 * ```yaml
 * operationId: cepro_docs_create
 * tags:
 *   - cepro_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/CeproDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/CeproDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/CeproDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/CeproDocCreate'
 *     description: ''
 * ```
 */
export const ceproDocsCreateOperation = (rest?: CeproDocsCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/cepro_docs/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/cepro_docs/' };
  };

/**
 * POST /dmx-server/cepro_docs/
 *
 * ```yaml
 * operationId: cepro_docs_create
 * tags:
 *   - cepro_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/CeproDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/CeproDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/CeproDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/CeproDocCreate'
 *     description: ''
 * ```
 */
export const ceproDocsCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: CeproDocsCreateQuery;
  request: CeproDocCreateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<CeproDocCreateResponse>> => {
  const operation = ceproDocsCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
